
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  layout: 'bijbelse-namen',
  async asyncData ({ $api, $log, store, params: { story }, route: { path }, error, $config }) {
    const {
      data: {
        items: page = [],
      } = {},
    } = await $api.pages.getOneBySlug('zoeken/' + story, {
      domain: $config.preprEnvironmentDomainBijbelseNamen,
    })

    // Check publication if exists and is complete
    if (!page || !page.length) {
      $log.warn(`Couldn't create '${story}' page.`)
      return error({ statusCode: 404, message: 'Oeps! De pagina is niet gevonden' })
    }

    // Set breadcrumbs for the page
    store.dispatch('breadcrumbs/set', {
      path: path,
      width: 6,
      showRoot: false,
      items: [
        {
          to: '/bijbelse-namen',
          label: 'Bijbelse namen',
        },
        {
          label: page[0].title,
        },
      ],
    })

    return {
      ...page[0],
      storyId: $config.storiesBijbelseNamen[story]?.id,
      storySlug: story,
      storyType: $config.storiesBijbelseNamen[story]?.type,
    }
  },
  data () {
    return {
      // Page data
      id: null,
      title: null,
      intro: null,
      featuredVideo: null,
      hero: null,
      content: null,
      podcast: null,
      program: null,
      topic: null,
      seo: null,
      slug: null,
      subtitle: null,
      social: null,
      // Story data
      storyId: null,
      storySlug: null,
      storyType: null,
      names: [],
      namesLimit: 10,
      namesTotal: 0,
      activeFilters: [],
    }
  },
  async fetch () {
    // Get names
    let { data: { items: names, meta: { total } } } = await this.$api.pages.getAll({
      limit: 9999,
      story: this.storyId,
      sort: 'title',
    })

    this.names.push(...names)
    this.namesTotal = total
  },
  computed: {
    isAllNamesVisible () {
      return this.namesLimit >= this.namesTotal || this.namesLimit >= this.filteredNames.length
    },
    filteredNames () {
      if (this.activeFilters.length > 0) {
        return this.names.filter(name => this.activeFilters.some((filter) => {
          return name.stories.map(story => story.slug).includes(filter.slug)
        }))
      }
      return this.names
    },
  },
  methods: {
    showMoreNames () {
      if (!this.isAllNamesVisible) {
        this.namesLimit = this.namesLimit + 25
      }
    },
  },
}
